export enum ETagVariants {
  FEATURED = 'featured',
  DEFAULT = 'default',
  LOCATION = 'location',
  OFFERS = 'offers',
}
